import React, { useEffect, useState } from 'react';
import { useApiRequestState } from '../../../../../../../../utils/api.utils';

export const TemporarySavedMessage = () => {
  const [saved, setSaved] = useState(false);
  const [allowedToShowSavedMessage, setAllowedToShowSavedMessage] = useState(false);

  const [showLoader] = useApiRequestState('updateTaskApi');

  useEffect(() => {
    // this avoids saved message from appearing when first rendering
    if (showLoader && !allowedToShowSavedMessage) {
      setAllowedToShowSavedMessage(true);
    }
  }, [showLoader, allowedToShowSavedMessage, setAllowedToShowSavedMessage]);

  useEffect(() => {
    if (!showLoader && allowedToShowSavedMessage) {
      setSaved(true);
      setTimeout(() => {
        setSaved(false);
      }, 3000);
    }
  }, [showLoader, setSaved, allowedToShowSavedMessage]);

  return <>{saved && <div className="italic green">Saved</div>}</>;
};
